import React from 'react';
import PropTypes from 'prop-types';
import ControlsPanelImage from './mc_controls_panel.svg';
import {Image} from '@learningblocks/storybook-components';
import {
  EVENTS,
  RPM_UPDATE_RATE,
  TIME_UPDATE_RATE,
  FUNTION_CALL_INTERVAL,
  PULSE_TIME,
  formatView,
} from './ControlPanel.utils';

import {
  NOTIFY_EVENTS,
  getNewTime
} from '../Microcentrifuge.utils';

export function ControlsPanel(props) {
  const [event, setEvent] = React.useState(null);

  const incrementRPM = () => props.setRPM(props.rpmValue + RPM_UPDATE_RATE);

  const decrementRPM = () => props.setRPM(props.rpmValue - RPM_UPDATE_RATE);

  const incrementTime = () => {
    const newTime = getNewTime(props.timeValue, TIME_UPDATE_RATE);
    props.setTimeValue(newTime);
  };

  const decrementTime = () => {
    const newTime = getNewTime(props.timeValue, -1 * TIME_UPDATE_RATE);
    props.setTimeValue(newTime);
  };

  if (event === EVENTS.INCREMENT_RPM) {
    setTimeout(incrementRPM, FUNTION_CALL_INTERVAL);
  }

  if (event === EVENTS.DECREREMENT_RPM) {
    setTimeout(decrementRPM, FUNTION_CALL_INTERVAL);
  }

  if (event === EVENTS.INCREMENT_TIME) {
    setTimeout(incrementTime, FUNTION_CALL_INTERVAL);
  }

  if (event === EVENTS.DECREMENT_TIME) {
    setTimeout(decrementTime, FUNTION_CALL_INTERVAL);
  }

  const onMouseDown = (eventType) => (event) => {
    setEvent(eventType);
  };

  const onMouseUp = (event) => {
    setEvent(null);
  };

  const setPulseTime = () => {
    if(props.balanced){
      props.setTimeValue(PULSE_TIME);
      props.runCentrifuge();
      props.onPulseSolutions();
    } else {
      props.alert(NOTIFY_EVENTS.NOT_RUNNABLE);
    }
  };

  const onClickStart = () => {
    props.runCentrifuge();
  };

  return (
    <div className={props.className}>
      <div className={`${props.className}_rpm`}>
        <div className={`${props.className}_rpm_value`}>
          <p>{props.rpmValue.toLocaleString()}</p>
        </div>
        <div className={`${props.className}_rpm_buttons`}>
          <span
            onMouseDown={onMouseDown(EVENTS.INCREMENT_RPM)}
            onMouseUp={onMouseUp}
            className={`${props.className}_rpm_buttons_up`}></span>
          <span
            className={`${props.className}_rpm_buttons_down`}
            onMouseDown={onMouseDown(EVENTS.DECREREMENT_RPM)}
            onMouseUp={onMouseUp}></span>
        </div>
      </div>
      <div className={`${props.className}_settime`}>
        <div className={`${props.className}_settime_value`}>
          <span className='hh'>{formatView(props.timeValue.getHours())}</span>
          <span className='mm'>{formatView(props.timeValue.getMinutes())}</span>
          <span className='ss'>{formatView(props.timeValue.getSeconds())}</span>
        </div>
        <div className={`${props.className}_settime_buttons`}>
          <span
            onMouseDown={onMouseDown(EVENTS.INCREMENT_TIME)}
            onMouseUp={onMouseUp}
            className={`${props.className}_settime_buttons_up`}></span>
          <span
            onMouseDown={onMouseDown(EVENTS.DECREMENT_TIME)}
            onMouseUp={onMouseUp}
            className={`${props.className}_settime_buttons_down`}></span>
        </div>
      </div>
      <div className={`${props.className}_timeleft`}>
        <span className='hh'>{formatView(props.timeLeft.getHours())}</span>
        <span className='mm'>{formatView(props.timeLeft.getMinutes())}</span>
        <span className='ss'>{formatView(props.timeLeft.getSeconds())}</span>
      </div>
      <div className={`${props.className}_image`}>
        <Image
          src={ControlsPanelImage}
          alt='Controls Panel'
          className={`${props.className}_image_main`}
        />
        <span
          onClick={setPulseTime}
          className={`${props.className}_image_pulse`}
        />
        <span
          className={`${props.className}_image_start`}
          onClick={onClickStart}
        />
      </div>
    </div>
  );
}

ControlsPanel.propTypes = {
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Time left for centrifuge to run to completion
   */
  timeLeft: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
};

ControlsPanel.defaultProps = {};
